import { useEffect, useState } from "react";
import { useAppContext } from "utils/context";
import { useDispatch } from "react-redux";
import {
  CONTRACT_STATUS,
  intiUserInfo,
} from "containers/pmaOnboarding/services/data.transformers";
import {
  getPmaContracts,
  postPmaOtpSend,
} from "containers/pmaOnboarding/services/service";
import { useProfileData } from "containers/home/services/cache.data";

import ContractList from "./list/list";
import ContractView from "./view/ContractView";
import UserInfoDrawer from "./drawer/drawer";
import ContractOTP from "./otp";

const PmaContract = ({
  addressData,
  currentStageDetails,
  data,
  otpError,
  contractStatus,
  onbUuid,
  onChangeContractStates,
  onCloseContract,
  onFinishContract,
  onUpdateAddressData,
}) => {
  const { instance } = useAppContext();
  const dispatch = useDispatch();
  useProfileData(instance, null, dispatch);

  const userInfo = currentStageDetails?.page_info?.find(
    (el) => el.component_name === "user_info"
  )?.infos;
  const digitalSign = data?.stages
    ?.find((el) => el?.key === "SIGN_CONTRACT")
    ?.page_info?.find((el) => el.component_name === "digital_sign")
    ?.infos?.[0]?.value;


  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingOTP, setLoadingOTP] = useState(false);
  const [sendingOTP, setSendingOTP] = useState(false);
  const [optData, setOtpData] = useState({});
  
  const [otpSuccess, setOtpSuccess] = useState(false);

  const [currentContract, setCurrentContract] = useState(null);

  const [contractList, setContractList] = useState([]);

  const handleGetPmaContracts = async () => {
    setLoading(true);
    const response = await getPmaContracts(instance, onbUuid);
    if (response) {
      setContractList(response?.contracts ?? []);
    }
    setLoading(false);
  };

  const handleShowContract = (item) => {
    onChangeContractStates(CONTRACT_STATUS.VIEW);
    setCurrentContract(item);
  };

  const handleCloseContract = () => {
    onChangeContractStates(CONTRACT_STATUS.List);
  };

  const handleShowUserInfo = () => {
    setVisible(true);
  };

  const handleCloseUserInfo = () => setVisible(false);

  const handleSendOTP = async () => {
    setLoadingOTP(true);
    const response = await postPmaOtpSend(instance, onbUuid);
    if (response?.data) {
      setVisible(false);
      setOtpData(response?.data);
      onChangeContractStates(CONTRACT_STATUS.OTP);
    }
    setLoadingOTP(false);
  };

  useEffect(() => {
    if (addressData === null) {
      onUpdateAddressData(intiUserInfo(userInfo));
    }
    handleGetPmaContracts();
  }, []);

  const renderContract = () => {
    switch (contractStatus) {
      case CONTRACT_STATUS.VIEW:
        return (
          <ContractView
            currentContract={currentContract}
            onbUuid={onbUuid}
            onCloseContract={handleCloseContract}
          />
        );

      case CONTRACT_STATUS.OTP:
        return (
          <ContractOTP
            loadingOTP={loadingOTP}
            sendingOTP={sendingOTP}
            digitalSign={digitalSign}
            optData={optData}
            otpError={otpError}
            otpSuccess={otpSuccess}
            onCloseContract={onCloseContract}
            onFinishContract={(value) =>
              onFinishContract({
                addressData,
                value,
                setOtpSuccess,
                setSendingOTP,
              })
            }
            onSendOTP={handleSendOTP}
          />
        );

      case CONTRACT_STATUS.LIST:
      default:
        return (
          <ContractList
            data={contractList}
            loading={loading}
            onShowContract={handleShowContract}
            onShowUserInfo={handleShowUserInfo}
          />
        );
    }
  };

  return (
    <>
      {renderContract()}
      <UserInfoDrawer
        addressData={addressData}
        loadingOTP={loadingOTP}
        open={visible}
        onClose={handleCloseUserInfo}
        onSendOTP={handleSendOTP}
        onUpdateAddressData={onUpdateAddressData}
      />
    </>
  );
};

export default PmaContract;
